import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

// LeveSorte is a Brazil-only product — no English customer experience.
// Clear any stale cached language (e.g. "en" from browser detection in older builds).
try { localStorage.removeItem("language"); } catch (e) {}


i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "pt",              // Always Portuguese — BR-only product
    fallbackLng: "pt",     // Fallback also Portuguese
    supportedLngs: ["pt"], // Only PT supported — no English customer UI
    react: {
      useSuspense: false,   // no Suspense gate — keys render as "" during load, not blocking paint
    },
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
    initImmediate: true,    // async init — don't block JS execution
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    partialBundledLanguages: true,  // graceful late-arrival if backend is slow
  });

export default i18n;
